import React from 'react';
import { SHOW_ORDER_PROGRESS_STEPPER } from './orderProgressStepperUtils';

const TAB_COUNT = 3;
const CARD_COUNT = 3;

function SkeletonBlock({ className = '', ...props }) {
  return <span className={`account-orders-skeleton ${className}`.trim()} aria-hidden {...props} />;
}

function TabsSkeleton() {
  return (
    <div className="account-orders__tabs account-orders-skeleton-tabs" aria-hidden>
      {Array.from({ length: TAB_COUNT }, (_, i) => (
        <SkeletonBlock key={i} className="account-orders-skeleton--tab" />
      ))}
    </div>
  );
}

function OrderCardSkeleton() {
  return (
    <li className="account-orders__card account-orders__card--food account-orders-skeleton-card" aria-hidden>
      <div className="account-orders__food-card__header">
        <div className="account-orders__food-card__main account-orders-skeleton-card__main">
          <SkeletonBlock className="account-orders-skeleton--brand" />
          <SkeletonBlock className="account-orders-skeleton--loc" />
          <SkeletonBlock className="account-orders-skeleton--meta" />
          <SkeletonBlock className="account-orders-skeleton--link" />
        </div>
        <SkeletonBlock className="account-orders-skeleton--pill" />
      </div>

      <div className="account-orders__food-card__divider" aria-hidden />

      <div className="account-orders__food-card__items-row account-orders-skeleton-card__items-row">
        <SkeletonBlock className="account-orders-skeleton--items" />
        <SkeletonBlock className="account-orders-skeleton--total" />
      </div>

      <SkeletonBlock className="account-orders-skeleton--hint" />

      {SHOW_ORDER_PROGRESS_STEPPER ? (
        <div className="account-orders-skeleton-stepper" aria-hidden>
          {Array.from({ length: 7 }, (_, i) => (
            <SkeletonBlock key={i} className="account-orders-skeleton--step-dot" />
          ))}
        </div>
      ) : null}

      <div className="account-orders__food-card__footer account-orders-skeleton-card__footer">
        <SkeletonBlock className="account-orders-skeleton--btn" />
        <SkeletonBlock className="account-orders-skeleton--btn account-orders-skeleton--btn-sm" />
      </div>
    </li>
  );
}

/**
 * @param {{ part?: 'tabs' | 'list' | 'full' }} props
 */
export default function AccountMyOrdersLoadingSkeleton({ part = 'full' }) {
  if (part === 'tabs') return <TabsSkeleton />;
  if (part === 'list') {
    return (
      <section className="account-orders__section account-orders-skeleton-section" aria-hidden>
        <SkeletonBlock className="account-orders-skeleton--kicker" />
        <ul className="account-orders__list">
          {Array.from({ length: CARD_COUNT }, (_, i) => (
            <OrderCardSkeleton key={i} />
          ))}
        </ul>
      </section>
    );
  }

  return (
    <>
      <TabsSkeleton />
      <section className="account-orders__section account-orders-skeleton-section" aria-hidden>
        <SkeletonBlock className="account-orders-skeleton--kicker" />
        <ul className="account-orders__list">
          {Array.from({ length: CARD_COUNT }, (_, i) => (
            <OrderCardSkeleton key={i} />
          ))}
        </ul>
      </section>
    </>
  );
}
